import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import Icon from '../../../../components/ui/Icon/Icon'
import FeedbackSuccessModal from '../../../../components/home/FeedbackSuccessModal/FeedbackSuccessModal'
import ShareFeedbackPageForm from '../ShareFeedbackPageForm/ShareFeedbackPageForm'
import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'

import validateShareFeedback from '../../../../services/validation/ShareFeedback'

import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

import { MAIN, HELP_CENTER } from '../../../../services/data/profilePages.json'

import * as ProfileService from '../../../../services/api/requests/Profile'

import truncateString from '../../../../services/data/truncateString'

const MainPage = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const Header = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  background: var(--color-primary);

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('${MoreHeaderParticles}');
    background-repeat: no-repeat;
    background-position: right top;
  }
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const Content = styled.div`
  padding: 2rem 1.1875rem;
  overflow: auto;

  &::after {
    content: ' ';
    display: block;
    height: 2rem;
    width: 100%;
  }
`

const Greetings = styled.p`
  color: var(--color-primary);
  font-size: 1.25rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.6875rem;
  letter-spacing: 0.56px;
  text-align: center;
  margin: 0;
  margin-bottom: 1.25rem;
`

const Message = styled.p`
  font-size: 0.875rem;
  line-height: 1.3125rem;
  letter-spacing: 0.29px;
  text-align: center;
  margin: 0;
  margin-bottom: 2.1875rem;
`

class ShareFeedbackPage extends React.Component {
  state = {
    displaySuccessModal: false,
  }

  handleSubmit = async (values, state) => {
    const { accessToken, setProfileModalPage } = this.props

    state.setSubmitting(true)

    try {
      const feedback = {
        topic: values.topic,
        subject: values.subject,
        message: values.message,
        ...(Array.isArray(values.malls) &&
          values.malls.length > 0 && {
            mall: values.malls.join(', '),
          }),
      }

      await ProfileService.postFeedback(accessToken, feedback)

      this.setState({
        displaySuccessModal: true,
      })

      state.resetForm()
    } catch (error) {
      const { data = {}, status } = error.response || {}
      const { message = 'Network Error' } = data || {}

      setProfileModalPage(MAIN)
      state.setStatus({
        status,
        error: message,
      })
    }

    state.setSubmitting(false)
  }

  closeSuccessModal = () => {
    this.setState({
      displaySuccessModal: false,
    })
  }

  render() {
    const { displaySuccessModal } = this.state
    const { setProfileModalPage, primaryInfo, accessToken, malls } = this.props
    const { firstName, lastName, email } = primaryInfo || {}

    return (
      <MainPage>
        <Header>
          <ReturnIcon
            onClick={() =>
              setProfileModalPage(accessToken ? HELP_CENTER : MAIN)
            }
          >
            <Icon name="slide-left" />
          </ReturnIcon>
          <Title>Share your Feedback</Title>
        </Header>
        <Content>
          <Greetings>
            {firstName ? `Hello ${truncateString(firstName, 20)},` : 'Hi!'}
            <br />
            How can we help you?
          </Greetings>
          <Message>
            Let us know how we can make your experience amazing. We’ll get back
            to you soon.
          </Message>
          <AccessibleForm
            onSubmit={this.handleSubmit}
            component={ShareFeedbackPageForm}
            componentProps={{ accessToken, malls }}
            initialValues={
              accessToken
                ? {
                    name: `${firstName} ${lastName}`,
                    email,
                    topic: '',
                    malls: [],
                    subject: '',
                    message: '',
                  }
                : {}
            }
            validate={validateShareFeedback}
            action="/a/avatar"
            method="post"
          />
        </Content>
        <FeedbackSuccessModal
          show={displaySuccessModal}
          onClose={this.closeSuccessModal}
          firstName={firstName}
        />
      </MainPage>
    )
  }
}

ShareFeedbackPage.defaultProps = {
  setProfileModalPage: () => {},
  primaryInfo: {},
}

ShareFeedbackPage.propTypes = {
  setProfileModalPage: PropTypes.func,
  primaryInfo: PropTypes.object,
}

export default ShareFeedbackPage
